import { EmployeeStatus } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { useMemo } from "react";

export const useEmployeeStatusOptions = () => {
  const { t } = useResource();

  return useMemo(
    () =>
      Object.values(EmployeeStatus).map((status) => ({
        code: status,
        name: t(Resources.Employee.EmployeeStatus[status]),
      })),
    [t],
  );
};
